package com.wintermar.inspection.feature.domain.usecase.auth

import com.wintermar.inspection.core.data.AppSetting

interface GetAuthStatusUseCase {
    operator fun invoke(): Boolean
}

class GetAuthStatusUseCaseImpl(
    private val appSetting: AppSetting
) : GetAuthStatusUseCase {
    override fun invoke(): Boolean {
        return appSetting.isLoggedIn()
    }
}
